import { render, staticRenderFns } from "./InvoiceCreditNoteView.vue?vue&type=template&id=b1c7a2c0&"
import script from "./InvoiceCreditNoteView.vue?vue&type=script&lang=js&"
export * from "./InvoiceCreditNoteView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports